/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";

import {
  Select,
  TextArea,
  InputField,
  MyMessage,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { usePartnerContext } from "../../context/PartnerContext";
import { defaultImage } from "../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../ui/ImageKitLibrary";
import { FOLDERS } from "../doseeData/utils/Utils";
import { FiImage, FiBriefcase, FiAlignLeft } from "react-icons/fi";

const Add = () => {
  const { createOnePartner } = usePartnerContext();

  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [title, setTitle] = useState(null);
  const [partnerStatus, setPartnerStatus] = useState(1);
  const [description, setDescription] = useState(null);

  const partnerRoutes = "/partner";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setThumbnail(null);
    setThumbnailId(null);
    setTitle(null);
    setDescription(null);
  };

  const responses = (isError: any, message: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const addOnePartnerHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      setLoading(false);
      return responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      name: title,
      description: description,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      status: partnerStatus,
    };

    const { status, message } = await createOnePartner(data);
    if (status === 200) {
      cleanFields();
      responses(false, message);
    } else {
      setLoading(false);
      responses(true, message);
    }
  };

  return (
    <AddPageShell
      backRoute={partnerRoutes}
      eyebrow="Marketing • Partners"
      title="Add Partner"
      subtitle="Showcase a partner with a clean logo and a short, clear description."
      icon={<FiBriefcase className="h-5 w-5" />}
      pills={[
        { label: "Status", value: partnerStatus === 1 ? "Visible" : "Hidden" },
      ]}
      loading={loading}
      submitLabel="Add Partner"
      onSubmit={addOnePartnerHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Brand Assets"
        hint="JPEG or PNG. Square logos look best."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={FOLDERS.PARTNERS}
        />
      </AddSection>

      <AddSection
        title="Partner Details"
        hint="Basic identity and visibility on the public site."
        icon={<FiBriefcase className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <InputField
            props={{
              id: "title",
              title: "Name",
              type: "text",
              required: true,
              value: title ? title : "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <Select
            props={{
              id: "event_status",
              title: "Status",
              required: true,
              option: ["visible", "invisible"],
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setPartnerStatus(1);
                else setPartnerStatus(0);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Description"
        hint="Aim for 120–160 characters for best readability."
        icon={<FiAlignLeft className="h-4 w-4" />}
      >
        <TextArea
          props={{
            id: "description",
            title: "Description",
            type: "text",
            required: true,
            value: description ? description : "",
            onChange: (e: any) => {
              setDescription(e.target.value);
              setError(null);
              setSuccess(null);
            },
          }}
        />
      </AddSection>
    </AddPageShell>
  );
};

export default Add;
